import { TranslateModule } from '@ngx-translate/core';
import { Customer, Maybe, Site } from '@iss/libs/graphql';
import { FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import { Component, Inject, Input, Self } from '@angular/core';

import { SiteInputComponent } from '../site-input';

import { Control, NOOP_VALUE_ACCESSOR } from '@iss/core/forms';

@Component({
  selector: 'wo-site-filter-selector',
  templateUrl: './site-filter-selector.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SiteInputComponent,
    TranslateModule,
  ],
})
export class SiteFilterSelectorComponent {
  @Input() public customerIds: Maybe<readonly Customer['id'][]>;
  @Input() public multi = true;

  public constructor(
    @Self() @Inject(NgControl) public readonly control: Control<FormControl<Site['id'] | null>>,
  ) {
    this.control.valueAccessor = NOOP_VALUE_ACCESSOR;
  }
}
